var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeployfailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39104",
    "data-name": "Rectangle 39104",
    width: 22,
    height: 22,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39103",
    "data-name": "Rectangle 39103",
    width: 16,
    height: 17,
    transform: "translate(0.417 -0.333)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket_launch_black_24dp_1_",
    "data-name": "rocket_launch_black_24dp (1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M5.667,13.917a2.743,2.743,0,0,0-1.943.807C2.642,15.805,2,20.334,2,20.334s4.528-.642,5.61-1.723a2.748,2.748,0,0,0-1.943-4.693Zm.651,3.4a9.31,9.31,0,0,1-1.989.7,8.982,8.982,0,0,1,.7-1.989.85.85,0,0,1,.642-.275.92.92,0,0,1,.651,1.567Zm9.818-4.638c5.83-5.83,3.887-10.368,3.887-10.368S15.484.369,9.654,6.2L7.372,5.74a1.861,1.861,0,0,0-1.659.5L2,9.966l4.583,1.962,3.823,3.823,1.962,4.583,3.382-4.125c.431-.431.953-.641.834-1.246ZM6.959,10.094,5.208,9.343,7.014,7.537l1.32.266A22.949,22.949,0,0,0,6.959,10.094Zm6.032,7.031-.752-1.751A21.858,21.858,0,0,0,14.522,14l.266,1.32Zm1.843-5.738a15.736,15.736,0,0,1-3.7,2.5L8.444,11.2a15.53,15.53,0,0,1,2.5-3.7c4.29-4.29,7.544-3.658,7.544-3.658S19.123,7.1,14.833,11.387Zm-.917-1.137a1.833,1.833,0,1,0-1.833-1.833A1.839,1.839,0,0,0,13.917,10.25Z",
    transform: "translate(-0.167 -0.167)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9607",
    "data-name": "Group 9607",
    transform: "translate(4.583 7.333)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4779",
    "data-name": "Path 4779",
    d: "M20.906,11.8l.281-.305-.276-.31L19.529,9.632l-.346-.388-.342.391-2.857,3.272L13.122,9.635l-.334-.381-.346.37-1.451,1.551-.294.314.294.313,2.988,3.182L10.6,18.7l-.284.312.288.309,1.375,1.474.343.368.334-.376,3.3-3.713,2.87,3.69.33.424.367-.393L20.9,19.317l.27-.289-.246-.309L17.963,15Z",
    transform: "translate(-5.443 -8.104)",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployfailed);
export default __webpack_public_path__ + "static/media/deployfailed.2524e0f2f9fd6e9ed56d7b40ca9948fc.svg";
export { ForwardRef as ReactComponent };